<template>
  <div class="hero">
    <div class="hero-body box has-background-white-bis container">
      <div class="is-mobile">
        <div class="columns is-mobile container is-centered">
          <div class="column is-6 has-text-left">
            <img :src="getLogo" class="rounded" alt="logo" style="max-height: 200px;">
          </div>
          <div class="column has-text-right top-step-btn-container">
            <b-button icon-left="chevron-left" class="is-info btn-mobile" :disabled="isPreviousStepTopBtnDisabled" @click="goToPreviousStep">Previous</b-button>
            <b-button icon-right="chevron-right" class="is-info ml-10 top-step-right-btn btn-mobile" disabled="true" ref="nextStepTopBtn" @click="goToNextStep" v-show="!isCompletedStepActive && !isMember">{{getNextButtonTitle}}</b-button>
          </div>
        </div>
      </div>

      <error-display-component :serverErrors="serverErrors" :serverErrorMessage="serverErrorMessage" id="error-container"></error-display-component>

      <div class="steps" id="stepsDemo" v-show="isPrintRequestLoaded">
        <div class="step-item is-success mt-10">
          <div class="step-marker mt-10 clickable" @click="showTab('review')">1</div>
          <div class="step-details">
            <p class="step-title">Review & Sign</p>
          </div>
        </div>
        <div class="step-item mt-10">
          <div class="step-marker mt-10 clickable" @click="showTab('payment')">2</div>
          <div class="step-details">
            <p class="step-title">Payment</p>
          </div>
        </div>
        <!-- <div class="step-item mt-10">
          <div class="step-marker mt-10">3</div>
          <div class="step-details">
            <p class="step-title">Terms</p>
          </div>
        </div> -->
        <div class="step-item mt-10">
          <div class="step-marker mt-10">3</div>
          <div class="step-details">
            <p class="step-title">Finish</p>
          </div>
        </div>
        <div class="steps-content">
          <div class="step-content has-text-left container is-white">
            <div class="columns is-multiline">
              <div class="column is-12 notification" style="z-index:5000">
                <div class="notification is-warning box is-flex-tablet notification-container" v-if="isMember && !signingCompleted">
                  <span class="is-hidden-mobile"><i class="fas fa-exclamation-triangle fa-2x"></i></span>
                  <span class="is-hidden-tablet"><i class="fas fa-exclamation-triangle fa-lg"></i></span>
                  <span class="ml-10 notification-content">
                    {{disabledHeaderText}}
                  </span>
                </div>
                <div class="notification is-link box is-flex-tablet notification-container" v-else>
                  <span class="is-hidden-mobile"><i class="fas fa-info-circle fa-2x"></i></span>
                  <span class="is-hidden-tablet"><i class="fas fa-info-circle fa-lg"></i></span>
                  <span class="ml-10 notification-content">
                    {{step1HeaderText}}
                  </span>
                </div>
                <div class="box notification-container" v-if="!signingCompleted && isSignatureRequired">
                  <i class="fas fa-hand-point-right fa-2x has-text-orange"></i>
                  <b-checkbox class="ml-10" v-model="confirmAndSign" :disabled="isMember"></b-checkbox>
                  I confirm the document details are correct and would like to proceed to sign.
                </div>
                <div class="notification is-danger box is-flex-tablet notification-container" v-if="signatureSaved" >
                  <i class="fas fa-exclamation-circle fa-2x is-hidden-mobile"></i>
                  <i class="fas fa-exclamation-circle fa-lg is-hidden-tablet"></i>
                  <span class="ml-10 notification-content">
                    I have agreed to be legally bound by this document and the <a @click="showTerms">EAG Terms of Service.</a>
                    <br /><br /><b-button icon-right="chevron-right" class="is-white" @click="goToNextStep">{{getNextButtonTitle}}</b-button>
                  </span>
                </div>
              </div>
              <div class="column is-12">
                <div class="field is-full" v-if="(hasPdfFile || hasSignedPdfFile) && pdfFile">
                  <pdf ref="pdfViewer" v-for="i in pdfFile.numPages" :key="i" :page="i" style="display: contents; width: 100%"
                    :src="pdfFile.src"
                    @num-pages="pageCount = $event"
                    @page-loaded="currentPage = $event">
                  </pdf>
                </div>
              </div>
              <div class="column is-12 notification" v-if="!signingCompleted && isSignatureRequired">
                <div class="box notification-container">
                  <i class="fas fa-hand-point-right fa-2x has-text-orange"></i>
                  <b-checkbox class="ml-10" v-model="confirmAndSign" :disabled="isMember"></b-checkbox>
                  I confirm the document details are correct and would like to proceed to sign.
                </div>
                <div class="notification is-danger box is-flex-tablet notification-container" v-if="signatureSaved">
                  <i class="fas fa-exclamation-circle fa-lg is-hidden-tablet"></i>
                  <i class="fas fa-exclamation-circle fa-2x is-hidden-mobile"></i>
                  <span class="ml-10 notification-content">
                    I have agreed to be legally bound by this document and the <a @click="showTerms">EAG Terms of Service.</a>
                    <br /><br /><b-button icon-right="chevron-right" class="is-white" @click="goToNextStep">{{getNextButtonTitle}}</b-button>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="step-content has-text-left box container steps-pay-finish-container" style="background-color: #f6f8fa !important;">
            <div class="columns is-multiline">
              <div class="column is-12">
                <div class="notification is-link is-flex-tablet notification-container">
                  <span>
                    <i class="fal fa-lg is-hidden-tablet" :class="getPaymentTitleIcon"></i>
                    <i class="fal fa-2x is-hidden-mobile" :class="getPaymentTitleIcon"></i>
                  </span>
                  <span class="ml-10">{{step2HeaderText}}</span>
                </div>
              </div>
              <div class="column is-12" v-if="isAmountToPay && !paymentCompleted">
                <square-web-pay :printRequest="currentPrintRequest" :dealerId="currentPrintRequest.dealerId" v-on:on-success="completePayment" :paymentGuid="paymentGuid"></square-web-pay>
              </div>
            </div>
          </div>
          <!-- <div class="step-content has-text-left container is-white box">
            <div class="columns is-multiline">
              <div class="column is-12">
                <div class="field is-full" v-if="termsPdfFile">
                  <pdf ref="pdfViewer" v-for="i in termsPdfFile.numPages" :key="i" :page="i" style="display: contents; width: 100%"
                    :src="termsPdfFile.src"
                    @num-pages="pageCount = $event"
                    @page-loaded="currentPage = $event">
                  </pdf>
                </div>
              </div>
            </div>
          </div> -->
          <div class="step-content has-text-left container notification is-success steps-pay-finish-container">
            <div class="is-flex-tablet notification-container">
              <i class="fas fa-check-circle fa-lg is-hidden-tablet"></i>
              <i class="fas fa-check-circle fa-2x is-hidden-mobile"></i>
              <span class="ml-10 completed-title">{{finishedTitle}}</span>
            </div>
            <div class="notification notification-container is-info mt-10" v-if="isPaymentRequired && !paymentCompleted">
              <div>{{ paymentNotificationText }}</div>
              <div class="mt-10"><b-button class="btn-mobile is-info is-light" @click="goToPreviousStep">Complete Payment</b-button></div>
            </div>
            <div class="notification-container mt-10" v-if="hasSignedPdfFile">Thank you, you have successfully completed signing your document.</div>
            <hr>
            <div class="notification-container" v-if="hasSignedPdfFile">You can download a copy of the signed document below for your personal records. You may close this window at your convenience.</div>
            <div class="is-full has-text-left mt-35 notification-container" v-if="hasSignedPdfFile">
              <file-selector v-model="signedPdfFiles" label="Signed Document" :multiple="false" :token="this.token" :required="false" :isBoxed="false" :enabled="false" :showFileOnly="true" destinationUrl="/upload/receive" :usePortalViewer="false" applyZindexClass="completed-step-zindex"></file-selector>
            </div>
          </div>
        </div>
        <div class="steps-actions">
          <div class="steps-action">
            <b-button icon-left="chevron-left" data-nav="previous" class="is-info btn-mobile" ref="previousStepBtn">Previous</b-button>
          </div>
          <div class="steps-action">
            <b-button icon-right="chevron-right" data-nav="next" class="is-info btn-mobile" disabled="true" ref="nextStepBtn" v-show="!isCompletedStepActive && !isMember">{{getNextButtonTitle}}</b-button>
          </div>
        </div>
      </div>
    </div>

    <b-modal :active.sync="isSignatureActive" scroll="keep" :has-modal-card="true" v-if="isSignatureActive" :canCancel="false" style="z-index:20000">
      <div class="modal-card" style="overflow: hidden;">
        <header class="modal-card-head">
          <div class="columns">
            <div class="column is-narrow">
              <switch-selector class="signature-switch" label="Apply Digital Signature" size="fa-sm" v-model="digitalSignatureSelected"></switch-selector>
            </div>
            <div class="column is-10">
              <p class="is-block modal-card-title">
                Signing Document
                <span v-if="digitalSignatureSelected" class="mt-10 help has-text-weight-dark is-success">a signature based on your name will be generated for you</span>
                <span v-else class="mt-10 help has-text-weight-dark is-success">use the signature pad below to capture your signature</span>
                <br />
                <span class="mt-10 help has-text-weight-light is-danger" v-if="signaturePadIsBlank">Save cannot be completed signatre pad is blank please try again.</span>
              </p>
            </div>
          </div>
        </header>
        <section class="modal-sign-body" :style="isMobile ? 'max-width: 500px; width: 500px;' : 'max-width: 960px; width: 960px;'" v-if="!digitalSignatureSelected">
          <vue-signature ref="signature" :sigOption="option" w="500px" h="192px" v-if="isMobile"></vue-signature>
          <vue-signature ref="signature" :sigOption="option" w="960px" h="192px" v-else></vue-signature>
        </section>
        <section class="is-block modal-card-info">
          <div class="columns is-multiline">
            <div class="column is-12 is-size-6">
              <b-checkbox v-model="acceptSignatureAgreement" class="check-align">
                <span>By signing my name above and clicking "Sign", I understand and agree that the above electronic signature is the legal equivalent of my manual signature on each and every document attached and will bind me to all terms and conditions contained therein.</span>
              </b-checkbox>
            </div>
            <div class="column is-12 is-size-6">
              <b-checkbox v-model="acceptTermsAgreement" class="check-align">
                <span>I accept and agree to all the <a @click="showTerms">Terms and Conditions</a> of the attached documents, which are incorporated herein by reference.</span>
              </b-checkbox>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot">
          <button class="button is-primary" :class="{'is-loading': loadingSign }" @click.prevent="onSign" :disabled="isSignButtonDisabled">Sign</button>
          <button class="button is-warning" @click.prevent="onClearSign" v-show="!digitalSignatureSelected">Clear</button>
          <button class="button is-danger" @click.prevent="onCancelSignNow">Cancel</button>
        </footer>
      </div>
    </b-modal>

    <b-modal :active.sync="isSkipPaymentConfirmationActive" scroll="keep" :has-modal-card="true" v-if="isSkipPaymentConfirmationActive" style="z-index:20000">
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Skip Payment Confirmation</p>
        </header>
        <section class="modal-card-body">
          <div class="box has-background-grey-lighter">
             <h1 class="title has-text-danger">We value your time!</h1>
          </div>
          <div class="notification is-warning is-flex">
            <span><i class="fal fa-question-circle fa-2x"></i></span>
            <span class="ml-10 has-text-left">
              Are you sure you want to skip payment? <br /> {{ skipPaymentConfirmationText }} <br />We also believe in paperless processing.
            </span>
          </div>
        </section>
        <footer class="modal-card-foot">
          <a class="button is-primary" @click="onSkipPayment">Yes</a>
          <a class="button is-danger" @click="isSkipPaymentConfirmationActive = false">No</a>
        </footer>
      </div>
    </b-modal>

    <b-loading :is-full-page="true" :active.sync="isLoading" :canCancel="false" style="z-index: 9999999"></b-loading>
  </div>
</template>
<script>

import bulmaSteps from 'bulma-steps/dist/js/bulma-steps'
import printRequestService from '@/services/printRequestService'
import utilitiesMixin from '@/mixins/generic/utilities'
import vueSignature from 'vue-signature'
import SquareWebPayControl from '@/components/generic/SquareWebPayControl'
import FileSelector from '@/components/generic/FileSelector'
import pdf from 'vue-pdf'
import ErrorDisplayComponent from '@/components/generic/ErrorDisplayComponent'
import SwitchSelector from '@/components/generic/SwitchSelector'

export default {
  name: 'PrintRequest',
  inject: {
    $validator: '$validator'
  },
  mixins: [utilitiesMixin],
  components: {
    pdf,
    'square-web-pay': SquareWebPayControl,
    'vue-signature': vueSignature,
    'file-selector': FileSelector,
    'error-display-component': ErrorDisplayComponent,
    'switch-selector': SwitchSelector
  },
  props: {
    printRequestId: {
      type: Number,
      default: 0
    },
    token: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isMobile: window.innerWidth <= 700,
      currentPrintRequest: null,
      currentPrintRequestId: 0,
      isLoading: false,
      pdfFiles: [],
      pdfFile: null,
      isSaving: false,
      serverErrors: [],
      serverErrorMessage: '',
      isSignatureActive: false,
      signatureSaved: false,
      pdfFilePreviewDownloading: false,
      option: {
        penColor: 'rgb(0, 0, 0)',
        backgroundColor: 'rgb(255,255,255)'
      },
      loadingSign: false,
      confirmAndSign: false,
      paymentVisible: false,
      currentStep: undefined,
      confirmSkipPayment: false,
      isSkipPaymentConfirmationActive: false,
      signedPdfFiles: [],
      signaturePadIsBlank: false,
      acceptSignatureAgreement: false,
      acceptTermsAgreement: false,
      digitalSignatureSelected: true,
      currentPage: 0,
      pageCount: 0,
      paymentGuid: this.$uuid.v4(),
      termsPdfFile: null,
      isMember: document.cookie.indexOf('PRINT=ONE') > -1
    }
  },
  computed: {
    hasPdfFile: function () {
      return this.pdfFiles && this.pdfFiles.length > 0
    },
    signingCompleted: function () {
      return this.currentPrintRequest && this.currentPrintRequest.isSigned === true
    },
    paymentCompleted: function () {
      return this.currentPrintRequest && this.currentPrintRequest.isPaid
    },
    fullName: function () {
      return this.currentPrintRequest ? this.currentPrintRequest.payerFirstName + ' ' + this.currentPrintRequest.payerLastName : ''
    },
    isPrintRequestLoaded: function () {
      return this.currentPrintRequest !== null && this.currentPrintRequest !== undefined
    },
    isPaymentRequired: function () {
      return this.isPrintRequestLoaded && this.currentPrintRequest.paymentRequired
    },
    isSignatureRequired: function () {
      return this.isPrintRequestLoaded && this.currentPrintRequest.signatureRequired
    },
    isNextBtnDisabledOnReview: function () {
      if (this.isSignatureRequired && !this.signingCompleted) {
        return !this.signatureSaved
      }
      return false
    },
    isReviewAndSigningStepActive: function () {
      return this.currentStep === 0
    },
    isPaymentStepActive: function () {
      return this.currentStep === 1
    },
    isCompletedStepActive: function () {
      return this.currentStep === 2
    },
    isAmountToPay: function () {
      return this.isPrintRequestLoaded && this.currentPrintRequest.amount && this.currentPrintRequest.amount > 0
    },
    getLogo: function () {
      if (this.currentPrintRequest && this.currentPrintRequest.dealerBrand) {
        let result = ''
        if (this.currentPrintRequest.brandLogos) {
          this.currentPrintRequest.brandLogos.forEach((brandLogo) => {
            const dealerBrand = this.currentPrintRequest.dealerBrand.toLowerCase()
            const brandMake = brandLogo.forVehicleMakeName.toLowerCase()
            if (dealerBrand.includes(brandMake)) {
              if (brandLogo && brandLogo.fileLocation && this.isValidURL(brandLogo.fileLocation)) {
                result = brandLogo.fileLocation
              }
            }
          })
          if (result) {
            return result
          } else {
            if (this.currentPrintRequest.dealerLogoLocation) {
              if (this.isValidURL(this.currentPrintRequest.dealerLogoLocation)) {
                result = this.currentPrintRequest.dealerLogoLocation
                return result
              }
            }
          }
        } else {
          if (this.currentPrintRequest.dealerLogoLocation) {
            if (this.isValidURL(this.currentPrintRequest.dealerLogoLocation)) {
              result = this.currentPrintRequest.dealerLogoLocation
              return result
            }
          }
        }
      }
      return require('../assets/eag_logo.png')
    },
    isPreviousStepTopBtnDisabled: function () {
      return this.isReviewAndSigningStepActive
    },
    getNextButtonTitle: function () {
      if (this.isPaymentStepActive && this.isPaymentRequired && !this.paymentCompleted) {
        return 'Skip Payment'
      }
      return 'Next'
    },
    hasSignedPdfFile: function () {
      return this.signedPdfFiles && this.signedPdfFiles.length > 0
    },
    requesterName: function () {
      return this.currentPrintRequest !== null ? this.currentPrintRequest.printRequesterName : ''
    },
    step1HeaderText: function () {
      if (this.signingCompleted) {
        return 'Document signing has been completed, no further action required on step 1.'
      }
      const paymentText = this.isAmountToPay && !this.paymentCompleted ? 'You may also make payment.' : ''
      return this.requesterName + ' has requested that you review the following document and sign where applicable. ' + paymentText + ' To continue, use the Next button'
    },
    step2HeaderText: function () {
      if (this.isAmountToPay && !this.paymentCompleted) {
        return 'Would you like to make a payment?'
      }

      if (this.isAmountToPay && this.paymentCompleted) {
        return 'Payment has been completed, no further action required on step 2.'
      }

      return 'Payment is not required, you can move onto next step'
    },
    getPaymentTitleIcon: function () {
      return this.isAmountToPay && !this.paymentCompleted ? 'fa-question-circle' : 'fa-info-circle'
    },
    isSignButtonDisabled: function () {
      return this.digitalSignatureSelected ? !this.acceptSignatureAgreement || !this.acceptTermsAgreement : !this.acceptSignatureAgreement || !this.acceptTermsAgreement || (this.$refs.signature && this.$refs.signature.isEmpty())
    },
    finishedTitle: function () {
      if (this.paymentCompleted && this.hasSignedPdfFile) return 'Complete!'
      if (this.paymentCompleted && !this.hasSignedPdfFile) return 'Payment Complete!'
      if (!this.paymentCompleted && this.hasSignedPdfFile) return 'Signing Complete!'
      return 'Review Complete!'
    },
    isJetSkiMiami: function () {
      return this.currentPrintRequest.dealerBrand.toLowerCase() === 'jet ski of miami'
    },
    paymentNotificationText: function () {
      return this.isJetSkiMiami ? 'Are you sure you do not want to go back and complete payment to speed up processing of your watercraft?' : 'Are you sure you do not want to go back and complete payment to speed up processing of your vehicle?'
    },
    skipPaymentConfirmationText: function () {
      return this.isJetSkiMiami ? 'It will expedite the return of your watercraft.' : 'It will expedite the return of your vehicle.'
    },
    disabledHeaderText: function () {
      return 'Signing disabled, customer can proceed to sign the document using the link sent via email/sms.'
    }
  },
  methods: {
    async fetchPrintRequest (currentToken) {
      const that = this
      this.isLoading = true
      this.serverErrors = []
      this.serverErrorMessage = ''
      await printRequestService.getPrintRequest(currentToken).then(response => {
        that.isLoading = false
        if (response.errors) {
          that.serverErrors = response.errors
          throw new Error('Could not load requested information')
        } else if (!response.printrequestdata) {
          throw new Error('Could not load requested information')
        } else if (that.currentPrintRequest && !that.currentPrintRequest.attachments) {
          throw new Error('Could not load document')
        }

        that.currentPrintRequest = response.printrequestdata
        if (that.signingCompleted) {
          const signedFiles = that.currentPrintRequest.attachments.filter((x) => x.signed === true)
          signedFiles.forEach((item) => {
            item.loaded = true
            item.imageData = item.signedFileLocation
            item.fileType = that.getFileType(item.signedFileLocation)
            that.signedPdfFiles.push(item)
          })
          if (that.signedPdfFiles.length > 0) {
            this.isLoading = true
            that.onDownloadPdf(that.signedPdfFiles[0].signedFileLocation)
            // that.onDownloadTermsPdf(that.signedPdfFiles[1].signedFileLocation)
          }
          that.confirmAndSign = true
        } else {
          that.currentPrintRequest.attachments.forEach((item) => {
            item.loaded = true
            item.imageData = item.fileLocation
            item.fileType = that.getFileType(item.fileLocation)
            that.pdfFiles.push(item)
          })
          if (that.pdfFiles.length > 0) {
            this.isLoading = true
            that.onDownloadPdf(that.pdfFiles[0].fileLocation)
          }
        }
      }).catch((error) => {
        that.isLoading = false
        that.serverErrorMessage = error.message
      })
    },
    onDownloadPdf (fileLocation) {
      try {
        var file = {}
        file.name = 'Invoice'
        var fileUrl = process.env.VUE_APP_EAG_ROOT_API + 'document/download?url=' + encodeURI(fileLocation)
        const that = this
        file.src = pdf.createLoadingTask(fileUrl)
        file.src.promise.then(pdf => {
          file.numPages = pdf.numPages
          this.pdfFile = file
        }).catch(() => {
          that.isLoading = false
          that.serverErrorMessage = 'Unexpected error while attempting to download document.'
        })
      } catch (error) {
        this.isLoading = false
        this.serverErrorMessage = 'Unexpected error while attempting to download document.'
      }
    },
    // onDownloadTermsPdf (fileLocation) {
    //   try {
    //     var file = {}
    //     file.name = 'Terms and Conditions'
    //     var fileUrl = process.env.VUE_APP_EAG_ROOT_API + 'document/download?url=' + encodeURI(fileLocation)
    //     const that = this
    //     file.src = pdf.createLoadingTask(fileUrl)
    //     file.src.promise.then(pdf => {
    //       file.numPages = pdf.numPages
    //       this.termsPdfFile = file
    //     }).catch(() => {
    //       that.isLoading = false
    //       that.serverErrorMessage = 'Unexpected error while attempting to download document.'
    //     })
    //   } catch (error) {
    //     this.isLoading = false
    //     this.serverErrorMessage = 'Unexpected error while attempting to download document.'
    //   }
    // },
    reset: function () {
      this.pdfFiles = []
    },
    onError: function (error) {
      this.serverErrorMessage = error.message
      this.isLoading = false
      this.isSaving = false
    },
    signNow: function () {
      this.isSignatureActive = true
    },
    onCancelSignNow: function () {
      this.acceptSignatureAgreement = false
      this.acceptTermsAgreement = false
      this.isSignatureActive = false
      this.confirmAndSign = false
    },
    onClearSign () {
      this.$refs.signature.clear()
    },
    onUndoSign () {
      this.$refs.signature.undo()
    },
    onSign () {
      this.signaturePadIsBlank = false
      const that = this
      if (!this.digitalSignatureSelected && (this.$refs.signature && this.$refs.signature.isEmpty())) {
        this.signaturePadIsBlank = true
      } else {
        var png = !this.digitalSignatureSelected ? this.$refs.signature.save() : ''
        this.loadingSign = true
        this.serverErrors = []
        this.serverErrorMessage = ''

        var generatePdfModel = {
          signatureString: png,
          printRequestAttachmentId: this.pdfFiles[0].id,
          docType: this.currentPrintRequest.type,
          digitalSignature: this.digitalSignatureSelected
        }

        printRequestService.generatePdfWithSignature(generatePdfModel).then(response => {
          if (response.errors) {
            that.serverErrors = response.errors
            that.loadingSign = false
          } else {
            that.signatureSaved = true
            that.loadingSign = false
            that.isSignatureActive = false

            var item = {
              loaded: true,
              imageData: response.printRequestPdfUrls[0],
              fileType: that.getFileType(response.printRequestPdfUrls[0])
            }
            that.signedPdfFiles = []
            that.signedPdfFiles.push(item)

            // lets show the user the signed doc
            if (that.signedPdfFiles.length > 0) {
              that.onDownloadPdf(that.signedPdfFiles[0].imageData)
              // that.onDownloadTermsPdf(response.printRequestPdfUrls[1])
            }
          }
        }).catch((error) => {
          that.loadingSign = false
          that.serverErrorMessage = error.message
        })
      }
    },
    completePayment () {
      this.currentPrintRequest.isPaid = true
      this.goToNextStep()
    },
    goToNextStep () {
      this.enableNextButton()
      if (this.isReviewAndSigningStepActive && this.isNextBtnDisabledOnReview) {
        this.confirmAndSign = true
      } else {
        this.$refs.nextStepBtn.$el.click()
      }
    },
    goToPreviousStep () {
      this.$refs.previousStepBtn.$el.click()
    },
    disableNextButton () {
      this.$refs.nextStepBtn.$el.disabled = true
      this.$refs.nextStepTopBtn.$el.disabled = true
    },
    enableNextButton () {
      this.$refs.nextStepBtn.$el.disabled = false
      this.$refs.nextStepTopBtn.$el.disabled = false
    },
    setNextButtonStatus () {
      if (!this.isCompletedStepActive && !this.isMember) {
        this.enableNextButton()
      } else {
        this.disableNextButton()
      }
    },
    isValidURL (string) {
      var res = string.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g)
      return (res !== null)
    },
    onSkipPayment: function () {
      this.confirmSkipPayment = true
      this.goToNextStep()
      this.isSkipPaymentConfirmationActive = false
    },
    showTerms: function () {
      const route = this.$router.resolve({ path: '/print/printrequestterms' })
      window.open(route.href)
    },
    showTab: function (tabToShow) {
      if (tabToShow === 'payment') {
        if (this.isReviewAndSigningStepActive && !this.isNextBtnDisabledOnReview) {
          this.goToNextStep()
        } else if (this.isCompletedStepActive) {
          this.goToPreviousStep()
        }
      }

      if (tabToShow === 'review') {
        if (this.isPaymentStepActive) {
          this.goToPreviousStep()
        } else if (this.isCompletedStepActive) {
          this.goToPreviousStep()
          this.goToPreviousStep()
        }
      }
    },
    goToFinishTab: function () {
      this.goToNextStep()
      this.goToNextStep()
    },
    goToPayTab: function () {
      this.goToNextStep()
    }
  },
  watch: {
    confirmAndSign: function () {
      if (this.confirmAndSign && !this.signingCompleted) {
        this.isSignatureActive = true
        this.errors.clear()
      }
    },
    token: function (newValue, oldValue) {
      this.fetchPrintRequest(this.token)
    },
    currentPage: function (newValue, oldValue) {
      if (newValue > 0 && newValue === this.pageCount) {
        this.isLoading = false

        if (this.signingCompleted) {
          // move to finish tab if payment completed or payment not required and signing complete
          if (this.paymentCompleted || !this.isPaymentRequired) {
            this.goToFinishTab()
            return
          }
          // move to pay tab if payment required, payment not complete and signing complete
          if (this.isPaymentRequired && !this.paymentCompleted) {
            this.goToPayTab()
            return
          }
        }

        if (!this.isSignatureRequired) {
          // move to finish tab if payment completed or payment not required and signing not required
          if (this.paymentCompleted || !this.isPaymentRequired) {
            this.goToFinishTab()
            return
          }

          // move to pay tab if payment required, payment not complete and signing complete
          if (this.isPaymentRequired && !this.paymentCompleted) {
            this.goToPayTab()
          }
        }
      }
    }
  },
  async mounted () {
    bulmaSteps.attach('.steps', {
      beforeNext: id => {
        var beforeNextResult = {}
        if (this.isReviewAndSigningStepActive && this.isNextBtnDisabledOnReview) {
          beforeNextResult.errors = ['Document not signed']
          return beforeNextResult
        } else if (this.isPaymentStepActive && !this.confirmSkipPayment && this.isPaymentRequired && !this.paymentCompleted) {
          beforeNextResult.errors = ['Skip payment confirmation required']
          this.isSkipPaymentConfirmationActive = true
          return beforeNextResult
        } else {
          return beforeNextResult
        }
      },
      beforePrevious: id => {
      },
      onShow: id => {
        var elmnt = document.getElementById('main-page')
        elmnt.scrollTo(0, 0)
        this.currentStep = id
        this.setNextButtonStatus()
      }
    })
    await this.fetchPrintRequest(this.token)
    this.setNextButtonStatus()
    this.$emit('set-title-one', 'PRINT')
    this.$emit('set-title-two', 'REQUEST')
  },
  created () {
    this.$emit('is-home', false)
    this.$emit('show-footer', false)
  }
}
</script>
<style scoped>
  .modal-sign-body {
    position:relative;
    max-height: 200px !important;
    height: 200px !important;
    overflow-y: auto;
    background: white;
  }

  .modal-card-head, .modal-card-foot {
    padding: 20px !important;
  }

  .modal-card {
    overflow: auto;
    line-height: 1.5rem !important;
  }

  .modal-card-info {
    background-color: whitesmoke;
    padding: 10px;
  }

  .modal-card-body {
    height: 100% !important;
    line-height: 1.25rem !important;
    padding: 20px !important;
  }

  @media screen and (max-width: 284px) {
    .steps .step-item:not(:first-child)::before {
      height: 0rem;
    }
  }

  @media screen and (max-width: 330px) {
    .sq-web-pay-container {
      margin-left: -1.85rem !important;
    }
  }

  @media screen and (max-width: 500px) {
    .modal-sign-body {
      position:relative;
      overflow-y: auto;
      background: white;
    }
    .modal-pdf-body {
      position:relative;
      width:100vw;
      overflow-y: auto;
      background: white;
    }
  }

  @media screen and (max-width: 539px) {
    .top-step-right-btn {
      margin-top: 10px;
    }

    .notification-container {
      padding: 0.5rem !important;
      margin: 0.5rem !important;
      font-size: 0.85rem !important;
    }

    .completed-title {
      font-size: 1.2rem !important;;
    }

    .step-title {
      margin-top: 0.5rem !important;
      font-size: 1rem !important;
    }
  }

  @media screen and (max-width: 768px) {
    .notification-content {
      margin: 0rem !important;
    }

    .btn-mobile {
      font-size: 0.75rem !important;
      border-radius: 2px !important;
    }
  }

  .top-step-btn-container {
    align-self: end
  }

  .top-container {
    position: -webkit-sticky; /* Safari */
    position: sticky;
    top: 0;
    z-index: 10000;
  }

  .completed-title {
    font-size: 1.5rem;
  }

  .step-title {
    margin-top: 0.5rem !important;
  }

  .check-align {
    align-items: flex-start !important ;
  }

  .signature-switch {
    margin: 0, 0, 0, 0;
    padding: 0, 0, 0, 0;
  }
</style>
